import { render, staticRenderFns } from "./ViolateWordList.vue?vue&type=template&id=5417d805&scoped=true"
import script from "./ViolateWordList.vue?vue&type=script&lang=js"
export * from "./ViolateWordList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5417d805",
  null
  
)

export default component.exports